/*
 * @Author: 孙福聪
 * @Date: 2019-01-16 16:01:32
 * @Last Modified by: 史和祥
 * @Last Modified time: 2019-03-21 19:05:06
 */
// 导入模块
import Vue from "vue";
import axios from "axios";
import iView from "view-design";
import router from "@/router";
import SERVER_BASE_URL from "./config";
import { RequestCounter } from "./requestCounter";
// import store from '@/store'
const isProduction = process.env.NODE_ENV === "production";
Vue.use(iView);
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const http = axios.create({
  baseURL: SERVER_BASE_URL,
  // timeout: 8000,
  timeout: 600000,
  headers: {}
});
// 是否携带cookie
http.defaults.withCredentials = true;
/** 路由组件钩子 */
http.defaults.headers.common.token = sessionStorage.getItem("tokenTest");

let timeoutModalVisible = false;
let networkErrorModalVisible = false;

const requestCounter = RequestCounter.getInstance();
const increaseCount = (config) => {
  if (config.url) {
    requestCounter.increment(config.url);
  }
};
const decreaseCount = (config) => {
  console.log(config.url);
  if (config.url) {
    requestCounter.decrement(config.url);
  }
};


router.beforeEach((to, path, next) => {
  // console.log(to, path, "fetch")
  if (to.name === "login") {
    http.defaults.headers.common.token = "";
  } else if (!http.defaults.headers.common.token) {
    if (sessionStorage.getItem("tokenTest")) {
      http.defaults.headers.common.token = sessionStorage.getItem("tokenTest");
    }
  }
  next();
});
if (!isProduction) {
  http.get("./version/get").then(res => {
    iView.Message.info({
      content: `代码千万行,注释第一行;编程不规范,同事两行泪，哲寻代码委员会提醒您，当前软件SVN版本为${res.data.version
        }`,
      duration: 1,
      closable: true
    });
  });
}

http.interceptors.request.use((request) => {
  increaseCount(request);
  return request;
});

// 添加响应拦截器
http.interceptors.response.use((response) => {
  // console.log(response);
  decreaseCount(response.config);
  response.config.cancelToken = source.token;
  if (response.data.tokenValidateError) {
    source.cancel(response.data.message);
    return iView.Modal.error({
      title: "错误",
      content: response.data.message,
      okText: "退出",
      onOk() {
        sessionStorage.clear();
        sessionStorage.clear();
        router.replace("/");
      }
    });
  }
  if (!response.data.success) {
    let message = response.data.message;
    if (message.includes("无效输入文本")) {
      message = "请填写有效文本（包含文字）";
      iView.Message.error(message);
    } else if (!response.request.responseURL.includes("updateCaseExperiment")) {
      iView.Message.error({
        content: response.data.message,
        duration: 2,
        closable: true
      });
    }
  }
  // 对响应数据做点什么
  return response;
}, (error) => {
  decreaseCount(error.config);
  if (error.code === "ERR_NETWORK" && !networkErrorModalVisible) {
    requestCounter.reset();
    source.cancel();
    networkErrorModalVisible = true;
    iView.Modal.info({
      title: "系统提示",
      content: "网络连接出错，请重试。",
      onOk() {
        networkErrorModalVisible = false;
        window.location.reload();
      }
    });
  }
  if (error.code === "ECONNABORTED" && !timeoutModalVisible) {
    requestCounter.reset();
    source.cancel();
    timeoutModalVisible = true;
    iView.Modal.info({
      title: "系统提示",
      content: "网络连接超时，请重试。",
      onOk() {
        timeoutModalVisible = false;
        window.location.reload();
      }
    });
  }
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default {
  http
};
